export default __webpack_public_path__ + "static/media/en_mobile_organization.1add2f19.png";